import { useContext, useState, useEffect } from 'react';
import type { EHR } from 'vim-os-js-browser/types';
import { VimOSContext } from '../vimOsContext';

export const useVimOSEncounter = (): EHR.Encounter | undefined => {
  const vimOS = useContext(VimOSContext);
  const [encounter, setEncounter] = useState<EHR.Encounter | undefined>(undefined);
  useEffect(() => {
    if (vimOS.ehr) {
      vimOS.ehr.subscribe('encounter', setEncounter);
      return () => {
        vimOS.ehr.unsubscribe('encounter', setEncounter);
      };
    }
  }, [vimOS]);
  return encounter;
};
